module.exports = __webpack_public_path__ + "img/logo.e5bc68ae.png";